export enum PassageOrderStatusEnum {
  /** Новая */
  NEW = 'NEW',
  /** В работе */
  IN_PROCESS = 'IN_PROCESS',
  /** Завершена */
  COMPLETED = 'COMPLETED',
}